"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePhoneContext = exports.PhoneProvider = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const PhoneContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const PhoneProvider = ({
  children,
  customTenant,
  currentCustomerId
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const [phones, setPhones] = (0, _react.useState)([]);
  const [phoneMetadata, setPhoneMetadata] = (0, _react.useState)({});
  const [dataCompletenessMetadata, setDataCompletenessMetadata] = (0, _react.useState)();
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const api = (0, _globalApiClientReact.useApiClient)();
  const {
    customerId
  } = (0, _auth.useToken)();
  const fetchPhoneMetadata = (0, _react.useCallback)(async () => {
    const {
      data
    } = await (0, _globalApiClientReact.getCustomerPhonesMetadata)(api, currentCustomerId ?? customerId);
    setPhoneMetadata(data);
  }, [api, customerId, currentCustomerId]);
  const fetchDataCompletenessMetadata = (0, _react.useCallback)(async () => {
    const {
      data
    } = await (0, _globalApiClientReact.getCustomerProfileCompletenessMetadata)(api, currentCustomerId ?? customerId);
    setDataCompletenessMetadata(data);
  }, [api, customerId, currentCustomerId]);
  const refreshPhones = (0, _react.useCallback)(async () => {
    setIsLoading(true);
    try {
      const {
        data: fetchedPhones
      } = await (0, _globalApiClientReact.getCustomerPhones)(api, currentCustomerId ?? customerId);
      setPhones(fetchedPhones.telephonesCollection);
    } finally {
      setIsLoading(false);
    }
  }, [api, customerId, currentCustomerId]);
  const loadMetadata = (0, _react.useCallback)(async () => {
    setIsLoading(true);
    try {
      await fetchPhoneMetadata();
      await fetchDataCompletenessMetadata();
    } finally {
      setIsLoading(false);
    }
  }, [fetchDataCompletenessMetadata, fetchPhoneMetadata]);
  (0, _react.useEffect)(() => {
    refreshPhones();
    loadMetadata();
  }, [customerId, loadMetadata, refreshPhones]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PhoneContext.Provider, {
    value: {
      phones,
      setPhones,
      refreshPhones,
      phoneMetadata,
      dataCompletenessMetadata,
      loadMetadata,
      isLoading,
      tenant: customTenant ?? tenant,
      currentCustomerId
    },
    children: children
  });
};
exports.PhoneProvider = PhoneProvider;
const usePhoneContext = () => {
  const context = (0, _react.useContext)(PhoneContext);
  if (!context) {
    throw new Error('usePhoneContext must be used within a PhoneProvider');
  }
  return context;
};
exports.usePhoneContext = usePhoneContext;
